<template>
    <div id="ModalShowData" class="modal fade in" data-backdrop="static" data-keyboard="false"  role="dialog">
        <div class="modal-dialog modal-el">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="modal-title">{{$t('words.details_data')}}: <b>{{data[description]}}</b></p>
                    <button type="button"  class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="table-responsive">
                        <table class="table table-sm table-bordered table-hover" id="showTable">
                            <tbody>
                                <tr v-for="(item, i) in headers" :key="i">
                                    <th class="col-md-3">{{i}}</th>
                                    <td><span v-html="data[item]"></span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button"  data-dismiss="modal" class="btn btn-default"><i class="fa fa-times"></i>
                        {{$t('words.close')}} </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    data: Object,
    headers: Object,
    description: String,
  }
};
</script>